import { GridReadyEvent, StatusPanelDef } from "ag-grid-community";
import { BaseAgGrid } from "../../components/grid/BaseAgGrid";
import { useCallback, useMemo, useRef, useState } from "react";
import useFillingGridColumns from "./useFillingGridColumns";
import { SiteTransport } from "src/app/transports/site";
import { useIntl } from "react-intl";
import UpsertEditOnSiteModalContainer from "../UpsertEditOnSiteModal/UpsertEditOnSiteModalContainer";
import { Order } from "src/app/types/orders/order";
import { AgGridReact } from "ag-grid-react"; // Add this import

const FillingGridContainer = () => {
    const { formatMessage } = useIntl();
    const gridRef = useRef<AgGridReact>(null);

    const [editModal, setEditModal] = useState(false);
    const [entity, setEntity] = useState<any | undefined>();

    const refreshRowData = async () => {
        if (gridRef?.current?.api) {
            const newData = await SiteTransport.monitoring.filling();
            gridRef.current.api.setRowData(newData);
        }
    };

    const updateGridOnSave = async () => {
        await refreshRowData();
    };

    const handleModals = (modal: "edit", data?: Order) => {
        switch (modal) {
            case "edit": {
                setEditModal((value) => !value);
                break;
            }
        }
        setEntity({
            orderId: data?.id,
        });
    };

    const gridReadyListener = useCallback(async (params: GridReadyEvent) => {
        params.api.setRowData(await SiteTransport.monitoring.filling());
    }, []);

    const statusBar = useMemo<{
        statusPanels: StatusPanelDef[];
    }>(() => {
        return {
            statusPanels: [{ statusPanel: "agTotalAndFilteredRowCountComponent", align: "left" }],
        };
    }, []);

    const gridColumns = useFillingGridColumns(handleModals);

    return (
        <div className="ag-theme-balham" style={{ height: "95%" }}>
            <h2 className="d-flex align-content-center mt-5 ms-5">
                {formatMessage({ id: "analyse.sites.title.filling" })}
            </h2>
            <BaseAgGrid
                listHandler={() => {}}
                columnDefs={gridColumns}
                asCellFilter={false}
                gridRef={gridRef}
                onGridReady={gridReadyListener}
                debounceVerticalScrollbar={true}
                statusBar={statusBar}
            />
            {editModal && entity && (
                <UpsertEditOnSiteModalContainer
                    entity={entity}
                    handleClose={() => handleModals("edit")}
                    updateGridOnSave={updateGridOnSave}
                />
            )}
        </div>
    );
};

export default FillingGridContainer;
